export enum CashDeliveryMethod {
  Check = 'Check',
  Wire = 'Wire',
}
